import { useMutation, useQueryClient } from '@tanstack/react-query';
import { networkQueryKeys, Networks } from '#api';
import { makeNetworkQueryOptions, networksQueryOptions } from '#api/networks.queries.ts';

export function useGetStartedMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: Networks.addNetwork,
    async onSuccess(network) {
      // Seed the caches before invalidating: invalidateQueries resolves even when its refetch
      // fails, and the GotStarted gate reads the cached list synchronously — a stale empty list
      // would bounce every admin-panel navigation back to /get-started.
      queryClient.setQueryData(networksQueryOptions.queryKey, (old) =>
        old ?
          {
            ...old,
            data: [...old.data, network],
            metadata: { ...old.metadata, totalCount: old.metadata.totalCount + 1 },
          }
        : old
      );
      queryClient.setQueryData(makeNetworkQueryOptions(network.id).queryKey, { data: network });
      await queryClient.invalidateQueries({ queryKey: networkQueryKeys.lists() });
    },
  });
}
